<section class="course-component">
  <aside>
    <app-menu-module-course></app-menu-module-course>
  </aside>
  <main>
      <router-outlet></router-outlet>
  </main>
</section>
